(() => {
  const init = (scope = document) => {
    const menuToggle = scope.querySelector('[data-menu-toggle]');
    const mobileMenu = scope.querySelector('[data-mobile-menu]');
    if (menuToggle && mobileMenu && !menuToggle.dataset.ready) {
      menuToggle.dataset.ready = 'true';
      const closeMenu = () => { menuToggle.setAttribute('aria-expanded', 'false'); mobileMenu.hidden = true; };
      menuToggle.addEventListener('click', () => { const open = menuToggle.getAttribute('aria-expanded') !== 'true'; menuToggle.setAttribute('aria-expanded', String(open)); mobileMenu.hidden = !open; });
      document.addEventListener('keydown', event => { if (event.key === 'Escape' && !mobileMenu.hidden) { closeMenu(); menuToggle.focus(); } });
      matchMedia('(min-width:1024px)').addEventListener('change', event => { if (event.matches) closeMenu(); });
    }
    scope.querySelectorAll('[data-product-root]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const form = root.querySelector('[data-product-form]');
      const variantInput = form?.querySelector('[name="id"]');
      const add = form?.querySelector('[data-add-to-cart]');
      const qty = form?.querySelector('[name="quantity"]');
      let variants = [];
      try { variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]'); } catch { return; }
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: root.dataset.currency || 'USD' }).format(cents / 100);
      const chooseImage = (url, target) => {
        const img = root.querySelector('[data-product-main-image]');
        if (img) { img.removeAttribute('srcset'); img.src = url; }
        root.querySelectorAll('[data-product-image]').forEach(button => { const active = button.dataset.productImage === url; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
        const panel = target ? document.getElementById(target) : null;
        const gallery = root.querySelector('.replica-gallery');
        if (panel && gallery && matchMedia('(min-width:1024px)').matches) gallery.scrollTo({ top: panel.offsetTop - gallery.offsetTop, behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
        if (panel && matchMedia('(min-width:768px) and (max-width:1023px)').matches) {
          const desktopImage = root.querySelector('.replica-gallery__desktop-images img');
          if (desktopImage) { desktopImage.removeAttribute('srcset'); desktopImage.src = url; }
        }
      };
      const updateVariant = () => {
        const variant = variants.find(v => String(v.id) === variantInput?.value);
        if (!variant) return;
        root.querySelectorAll('[data-variant-id]').forEach(button => { const active = button.dataset.variantId === String(variant.id); button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
        const price = root.querySelector('[data-product-price]');
        const compare = root.querySelector('[data-product-compare]');
        if (price) price.textContent = money(variant.price);
        if (compare) { compare.hidden = !(variant.compare_at_price > variant.price); compare.textContent = variant.compare_at_price ? money(variant.compare_at_price) : ''; }
        if (add) { add.disabled = !variant.available; add.textContent = variant.available ? add.dataset.labelAdd : add.dataset.labelSold; }
        if (variant.featured_image?.src) chooseImage(variant.featured_image.src);
        const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      };
      const buttons = root.querySelector('[data-variant-buttons]');
      if (buttons && variantInput) { buttons.hidden = false; variantInput.hidden = true; buttons.addEventListener('click', event => { const button = event.target.closest('[data-variant-id]'); if (!button) return; variantInput.value = button.dataset.variantId; variantInput.dispatchEvent(new Event('change', { bubbles: true })); }); }
      variantInput?.addEventListener('change', updateVariant);
      root.querySelectorAll('[data-product-image]').forEach(button => button.addEventListener('click', () => chooseImage(button.dataset.productImage, button.dataset.productTarget)));
      root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { qty.value = Math.max(1, (Number(qty.value) || 1) - 1); });
      root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { const max = qty.max ? Number(qty.max) : Infinity; qty.value = Math.min(max, (Number(qty.value) || 1) + 1); });
    });
    scope.querySelectorAll('[data-collection-sort]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      const form = select.closest('form');
      const submit = form.querySelector('[type="submit"]');
      if (submit) submit.hidden = true;
      select.addEventListener('change', () => form.requestSubmit());
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-product-form]');
    if (!form || !window.fetch) return;
    event.preventDefault();
    if (form.dataset.submitting === 'true') return;
    form.dataset.submitting = 'true';
    const add = form.querySelector('[data-add-to-cart]');
    const status = form.querySelector('[data-cart-status]');
    const originalLabel = add.textContent;
    const rootUrl = document.body.dataset.rootUrl || '/';
    add.disabled = true;
    add.textContent = document.body.dataset.cartAdding;
    status.textContent = '';
    let added = false;
    try {
      const response = await fetch(rootUrl + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : document.body.dataset.cartError);
      added = true;
      status.append(document.createTextNode(document.body.dataset.cartAdded + ' '));
      const link = document.createElement('a'); link.href = rootUrl + 'cart'; link.textContent = document.querySelector('[data-cart-link-label]')?.dataset.cartLinkLabel || 'View cart'; link.style.textDecoration = 'underline'; status.append(link);
      const cartResponse = await fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } });
      if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-cart-count]').forEach(count => { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; }); }
    } catch (error) {
      if (!added) status.textContent = error.message || document.body.dataset.cartError;
    } finally { form.dataset.submitting = 'false'; add.disabled = false; add.textContent = originalLabel; }
  });
})();
